import { Link, useLocation } from "react-router-dom";
import "../styles/navbar.css";

export default function Navbar() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const phoneNumber = "919983765215";

  const whatsappMessage = encodeURIComponent(
    "Hi VK Bike On Rent, I want to enquire about bike, scooty, taxi or other rental services in Udaipur."
  );

  const whatsappUrl =
    `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;

  return (
    <>
      {/* =====================================================
          DESKTOP HEADER
      ====================================================== */}

      <header className="site-header">
        <nav
          className="navbar-desktop"
          aria-label="Primary navigation"
        >
          {/* Logo */}

          <Link
            to="/"
            className="nav-logo"
            aria-label="VK Bike On Rent - Bike and Scooty Rental in Udaipur"
          >
            <img
              src="/vk-logo.png"
              alt="VK Bike On Rent logo"
              width="160"
              height="70"
              decoding="async"
            />
          </Link>

          {/* Main Navigation */}

          <div className="nav-links">
            <Link
              to="/"
              className={isActive("/") ? "active" : ""}
              aria-current={
                isActive("/") ? "page" : undefined
              }
            >
              Home
            </Link>

            <Link
              to="/bikes"
              className={isActive("/bikes") ? "active" : ""}
              aria-current={
                isActive("/bikes") ? "page" : undefined
              }
            >
              Bike Rental
            </Link>

            <Link
              to="/taxi"
              className={`highlight ${
                isActive("/taxi") ? "active" : ""
              }`}
              aria-current={
                isActive("/taxi") ? "page" : undefined
              }
            >
              Taxi Service
            </Link>

            <Link
              to="/horse-riding"
              className={
                isActive("/horse-riding")
                  ? "active"
                  : ""
              }
              aria-current={
                isActive("/horse-riding")
                  ? "page"
                  : undefined
              }
            >
              Horse Riding
            </Link>

            <Link
              to="/contact"
              className={
                isActive("/contact")
                  ? "active"
                  : ""
              }
              aria-current={
                isActive("/contact")
                  ? "page"
                  : undefined
              }
            >
              Contact
            </Link>
          </div>

          {/* Business Actions */}

          <div className="nav-actions">
            <span
              className="rating"
              aria-label="VK Bike On Rent Google rating"
            >
              ⭐ 4.8
              <br />
              Google Rating
            </span>

            <a
              href={`tel:+${phoneNumber}`}
              className="call-btn"
              aria-label="Call VK Bike On Rent"
            >
              📞 Call
            </a>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
              aria-label="Book a rental service with VK Bike On Rent on WhatsApp"
            >
              🟢 Book Now
            </a>
          </div>
        </nav>
      </header>

      {/* =====================================================
          MOBILE HEADER
      ====================================================== */}

      <header className="mobile-header">
        <div className="mobile-top">
          <Link
            to="/"
            aria-label="VK Bike On Rent home page"
          >
            <img
              src="/vk-logo.png"
              alt="VK Bike On Rent logo"
              width="130"
              height="58"
              decoding="async"
            />
          </Link>

          <div className="mobile-actions">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Book with VK Bike On Rent on WhatsApp"
            >
              🟢 Book Now
            </a>
          </div>
        </div>

        {/* Mobile Information Marquee */}

        <div
          className="mobile-info-bar"
          aria-hidden="true"
        >
          <div className="info-track">
            <span>🚀 Quick Booking</span>
            <span>⭐ 4.8 Google Rating</span>
            <span>🕒 Open 24 Hours</span>
            <span>🐎 Horse Riding Available</span>

            <span>🚀 Quick Booking</span>
            <span>⭐ 4.8 Google Rating</span>
            <span>🕒 Open 24 Hours</span>
            <span>🐎 Horse Riding Available</span>
          </div>
        </div>
      </header>

      {/* =====================================================
          MOBILE BOTTOM NAVIGATION
      ====================================================== */}

      <nav
        className="navbar-mobile"
        aria-label="Mobile navigation"
      >
        <Link
          to="/"
          className={isActive("/") ? "active" : ""}
          aria-label="Home"
          aria-current={
            isActive("/") ? "page" : undefined
          }
        >
          <span aria-hidden="true">🏠</span>
        </Link>

        <Link
          to="/bikes"
          className={isActive("/bikes") ? "active" : ""}
          aria-label="Bike rental"
          aria-current={
            isActive("/bikes") ? "page" : undefined
          }
        >
          <span aria-hidden="true">🏍️</span>
        </Link>

        <Link
          to="/taxi"
          className={isActive("/taxi") ? "active" : ""}
          aria-label="Taxi services"
          aria-current={
            isActive("/taxi") ? "page" : undefined
          }
        >
          <span aria-hidden="true">🚕</span>
        </Link>

        <Link
          to="/horse-riding"
          className={
            isActive("/horse-riding")
              ? "active"
              : ""
          }
          aria-label="Horse riding"
          aria-current={
            isActive("/horse-riding")
              ? "page"
              : undefined
          }
        >
          <span aria-hidden="true">🐎</span>
        </Link>

        <Link
          to="/contact"
          className={
            isActive("/contact")
              ? "active"
              : ""
          }
          aria-label="Contact VK Bike On Rent"
          aria-current={
            isActive("/contact")
              ? "page"
              : undefined
          }
        >
          <span aria-hidden="true">📞</span>
        </Link>
      </nav>
    </>
  );
}